import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { capturePageView } from '../analytics/posthog';

/**
 * Captures a PostHog `$pageview` every time the route changes.
 * Drop this hook into any top-level authenticated layout component.
 */
export default function usePostHogPageView() {
  const location = useLocation();

  useEffect(() => {
    capturePageView();
  }, [location.pathname]);
}
